import { isArray, isNull } from "../../util/TypeUtil";
import Content from "./Content";
import ContentFactory from "./ContentFactory";
import ContentTypes from "./ContentTypes";

/**
* MeetingNotesContent.js
* 
* Created on May 30, 2016, 11:11:11 PM
*
* @author Pascal van Beek for Ranj
**/
export default class MeetingNotesContent extends Content {

    constructor(languagePack, contentID, label) {
        super(MeetingNotesContent.NAME, MeetingNotesContent.TYPE, label, languagePack, contentID);
        this._attendees = [];
    }

    /*
     * 
     * @returns {undefined}
     */
    remove() {
        this.removeLanguagePackText(MeetingNotesContent.NOTES_TITLE_LABEL);
        this.removeLanguagePackText(MeetingNotesContent.NOTES_LABEL);
        this.removeLanguagePackText(MeetingNotesContent.LOCATION_LABEL);
        super.remove();
    }

    /*
     * 
     * @returns {MeetingNotesContent}
     */
    clone() {
        const clone = ContentFactory.getContent(ContentTypes.TYPE_MEETING_NOTES, this.getLanguagePack());
        clone.setContentID(this.getContentID());
        clone.setNotes(this.getNotes);
        clone.setNotesTitle(this.getNotesTitle());
        clone.setLocation(this.getLocation());

        for (let i = 0; i <= this._attendees.length; i++) {
            clone._attendees.push(this._attendees[i].clone());
        }

        return clone;
    }

    /*
     * Returns the attendees
     * @returns {Array}
     */
    getAttendees() {
        return this._attendees;
    }

    /*
     * Setter for the attendees
     * @param {type} array of TextContent
     * @returns {undefined}
     */
    setAttendees(attendees) {
        this._attendees = attendees;
    }

    /*
     * 
     * @param {type} property
     * @returns {unresolved}
     */
    getValueForProperty(property) {
        return this.getLanguagePackText(property);
    }

    /*
     * 
     * @param {String} property
     * @param {*} value
     * @returns {undefined}
     */
    setValueForProperty(property, value) {
        if (this.getValueForProperty(property) !== value) {
            this.setLanguagePackText(property, value);
        }
    }

    getNotes() {
        return this.getValueForProperty(MeetingNotesContent.NOTES_LABEL);
    }

    setNotes(value) {
        this.setValueForProperty(MeetingNotesContent.NOTES_LABEL, value);
    }

    getNotesTitle() {
        return this.getValueForProperty(MeetingNotesContent.NOTES_TITLE_LABEL);
    }

    setNotesTitle(value) {
        this.setValueForProperty(MeetingNotesContent.NOTES_TITLE_LABEL, value);
    }

    getLocationID() {
        return this.getValueForProperty(MeetingNotesContent.LOCATION_LABEL);
    }

    setLocationID(value) {
        this.setValueForProperty(MeetingNotesContent.LOCATION_LABEL, value);
    }

    /*
     * @returns {*}
     */
    convertToObject() {
        const object = super.convertToObject();
        object._attendees = [];
        for (let i = 0; i < this._attendees.length; i++) {
            object._attendees[i] = this._attendees[i].convertToObject();
        }
        return object;
    }

    setPropertiesFromObject(object) {
        if (!isNull(object.attendees) && isArray(object.attendees)) {
            for (let i = 0; i < object.attendees.length; i++) {
                this._attendees[i] = ContentFactory.getContentFromObject(object.attendees[i], this.getLanguagePack());
            }
            delete object.attendees;
        }

        super.setPropertiesFromObject(object);
    }

    getDescriptionLabel() {
        return `Meeting Notes: ${this.getNotes().substring(0, 8)}...`;
    }
}

MeetingNotesContent.TYPE = ContentTypes.TYPE_MEETING_NOTES;
MeetingNotesContent.NAME = "Meeting Notes";
MeetingNotesContent.NOTES_TITLE_LABEL = "notesTitle";
MeetingNotesContent.NOTES_LABEL = "notes";
MeetingNotesContent.LOCATION_LABEL = "location";
